/// <reference path="types/localbase.d.ts"/>
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/app/App';
import reportWebVitals from './reportWebVitals';
import ServiceWorkerProcess from './containers/serviceWorker/ServiceWorkerProcess';


ReactDOM.render(
  <React.StrictMode>
    <ServiceWorkerProcess />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
